import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import React from "react";
import routeConstants from "utils/routeConstants";

const links: SectionLandingLink[] = [
  {
    title: "Credit default notices",
    to: routeConstants.creditDefaultNotices,
    description:
      "Credit Default Notices are generated by the ECVAA system when a trading party enters or clears a Credit Default level. " +
      "There are 2 levels of Credit Default, level 1 and level 2.",
  },
  {
    title: "Events",
    to: routeConstants.events,
    description:
      "This page can be used to view System Warnings and Demand Control Instructions.",
  },
  {
    title: "Settlement messages",
    to: routeConstants.settlementMessages,
    description:
      "Settlement Messages are generated internally by the SAA. For example, when performing a settlement run, if no Market Index Data has " +
      "been received from a Market Index Data Provider effective on that day, the SAA will generate a system message.",
  },
  {
    title: "SO-SO trade prices",
    to: routeConstants.sosoTradePrices,
    description:
      "System operator to system operator (SO-SO) services are provided mutually with other transmission system operators connected to " +
      "Britain's transmission system via interconnectors.",
  },
];

const Notices: React.FC = () => (
  <SectionLandingPage
    title="Notices"
    description={
      <>
        <p>
          The Notices section provides key operational and market updates to
          ensure system transparency and keep participants informed.
        </p>
        <p>
          It includes Credit Default Notices from the Energy Contract Volume
          Aggregation Agent system (ECVAA), events such as System Warnings and
          Demand Control Instructions, Settlement Messages from the Settlement
          Administration Agent (SAA), and SO-SO Trade Prices which detail trades
          of System Operators, pricing, and volumes.
        </p>
      </>
    }
    links={links}
  />
);

export default Notices;
